import mitt from 'mitt';
import { E_MIDDLEWARE_STEPS } from '../types/middlewares.types';
import stepsMiddleware from '../middlewares/steps.middleware';
import ExecutionDelay from 'execution-delay';

const emitter = mitt();

emitter.on(E_MIDDLEWARE_STEPS.CHANGE, (to) => {
  ExecutionDelay.add(E_MIDDLEWARE_STEPS.CHANGE, () => stepsMiddleware.onChangeEmit(to as string), 500);
});

export default emitter;